export default __webpack_public_path__ + "static/lottery-wide-bg-281eabcafc74957d60d79d1ef20305b4.jpg";